export enum ID_QUERY_PARAM_KEYS {
  ALERT_ID = 'alert',
  TAB_NAME = 'tab',
}
